import { CreateContentRepositoryRequest } from "@contentchef/contentchef-types";
import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { Aside, AsideItem, ContainerWithAside, FormActions, RepositoryForm } from "../../../components";
import { NOTIFICATION_DEFAULT_MESSAGES, NOTIFICATION_KEY_CONSTANTS } from "../../../constants/notifications-constants";
import { userPermissionsTable } from "../../../constants/user-permissions-table";
import { withFormInitialization, withRepositoryFormStores } from "../../../hoc";
import { ManageFieldProvider } from "../../../providers/UserPermissionsProvider";
import { DataAttributesBuilder } from "../../../services/DataAttributesBuilder";
import {
  createErrorNotification,
  createInfoNotification,
  createSuccessNotification,
} from "../../../services/Notification";
import { CreateRepositoryProps, InjectedProps } from "./CreateRepositoryModel";

@inject("notificationStore", "repositoryStore")
@observer
class CreateRepository extends Component<CreateRepositoryProps> {
  get injected() {
    return this.props as InjectedProps;
  }

  componentWillUnmount() {
    const { notificationStore } = this.injected;
    const { notifications } = notificationStore;
    if (notifications.includes(NOTIFICATION_KEY_CONSTANTS.REPOSITORY_CREATE)) {
      notificationStore.closeNotification(NOTIFICATION_KEY_CONSTANTS.REPOSITORY_CREATE);
    }
  }

  createDataAttributes = () => {
    return new DataAttributesBuilder("repository")
      .setIdAttribute("addRepository")
      .setAddFormAttribute("repositoryCreate")
      .build();
  };

  onSubmitForm = async (values: CreateContentRepositoryRequest) => {
    const { formatMessage } = this.props.intl;
    const { notificationStore } = this.injected;
    createInfoNotification(
      NOTIFICATION_KEY_CONSTANTS.REPOSITORY_CREATE,
      formatMessage,
      NOTIFICATION_DEFAULT_MESSAGES.createAction,
    );
    try {
      await this.injected.repositoryStore.save(values);
      createSuccessNotification(formatMessage, NOTIFICATION_DEFAULT_MESSAGES.createAction);
    } catch (e) {
      notificationStore.closeNotification(NOTIFICATION_KEY_CONSTANTS.REPOSITORY_CREATE);
      createErrorNotification(formatMessage, NOTIFICATION_DEFAULT_MESSAGES.createAction);
    }
  };

  render() {
    const { notifications } = this.injected.notificationStore;
    return (
      <ContainerWithAside
        dataAttributes={this.createDataAttributes().Attributes}
        disableContent={notifications.includes(NOTIFICATION_KEY_CONSTANTS.REPOSITORY_CREATE)}
        renderAside={() => (
          <Aside>
            <AsideItem>
              <FormActions onSubmit={this.onSubmitForm} permissions={userPermissionsTable.FormActions.repository} />
            </AsideItem>
          </Aside>
        )}
      >
        <ManageFieldProvider permissions={userPermissionsTable.Forms.CreateRepositoryForm}>
          <RepositoryForm />
        </ManageFieldProvider>
      </ContainerWithAside>
    );
  }
}

export default withRepositoryFormStores(withFormInitialization(injectIntl(CreateRepository)));
